import React, { useCallback } from 'react';
import { UserIcon } from '@heroicons/react/20/solid';
import { useQueryClient } from '@tanstack/react-query';
import SearchLookup from './SearchLookup/SearchLookup';
import { getClients } from '../../api/clientApi';

const LOOKUP_LIMIT = 50;

const ClientLookupNative = ({
  label,
  onSelect,
  isError,
  placeholder = 'Search for a client...',
  maxDisplayLength = 50,
  disabled = false,
  required = false,
  defaultValue = null,
  onCreateNewClient = null,
}) => {
  const queryClient = useQueryClient();

  const mapClients = (clients) =>
    clients.map((c) => ({
      id: c._id,
      name: c.fullName,
      secondary: c.email,
      serviceAddress: c.serviceAddress,
    }));

  const searchClients = useCallback(
    async (query) => {
      const trimmed = (query || '').trim();
      try {
        if (!trimmed) {
          const data = await queryClient.fetchQuery({
            queryKey: ['clientLookup', 'browse', LOOKUP_LIMIT],
            queryFn: () => getClients({ search: '', archived: false, limit: LOOKUP_LIMIT }),
            staleTime: 5 * 60 * 1000,
          });
          return mapClients(data.clients);
        }
        const result = await getClients({ search: trimmed, archived: false, limit: LOOKUP_LIMIT });
        return mapClients(result.clients);
      } catch (error) {
        console.error('Client search error:', error);
        throw error;
      }
    },
    [queryClient]
  );

  return (
    <SearchLookup
      label={label}
      placeholder={placeholder}
      icon={<UserIcon className="size-5 text-ink-400" aria-hidden={true} />}
      searchFunction={searchClients}
      onSelect={onSelect}
      isError={isError}
      maxDisplayLength={maxDisplayLength}
      disabled={disabled}
      required={required}
      defaultValue={defaultValue}
      showChevron={true}
      allowEmptyQuery={true}
      onCreateNew={onCreateNewClient}
      createNewLabel="Add new client"
      sheetTitle="Select client"
      sheetSearchPlaceholder="Search clients..."
      resultCap={LOOKUP_LIMIT}
    />
  );
};

export default ClientLookupNative;
